<template>
  <generic-modal :title="$t('classroom')" ref="generic_modal" :is_wide="true">
    <form>
      <div class="title is-5" v-if="meta && meta.course && meta.course.name">
        <span class="icon">
          <i class="fa fa-book"></i>
        </span>
        {{ " " }}
        {{ meta.course.name }}
      </div>
      <div class="subtitle is-5" v-if="meta && meta.professor">
        <span class="icon">
          <i class="fa fa-user"></i>
        </span>
        {{ " " }}
        {{ meta.professor.first_name }} {{ meta.professor.first_surname }}
      </div>

      <div v-if="meta && meta.settings">
        <div class="field">
          <label class="label"> {{ $t("virtual classroom url") }} </label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.settings.virtual_classroom_url"
              placeholder="https://meet.google.com/abc-defg-hij"
            />
          </div>
        </div>
        <div class="field">
          <div
            class="button is-primary is-small is-pulled-right"
            @click="add_stage"
          >
            <span class="icon">
              <i class="fa fa-plus"></i>
            </span>
            <span>{{ $t("add stage") }}</span>
          </div>
          <label class="label"> {{ $t("stages") }} </label>
          <div class="control">
            <div class="tabs is-toggle is-fullwidth" ref="tabs">
              <ul>
                <li
                  :data-tab="'stage_' + sidx"
                  @click="change_active_tab($event, this)"
                  v-for="(stage, sidx) in meta.settings.stages || []"
                  :key="sidx"
                >
                  <a>
                    <i class="book icon" aria-hidden="true"></i>
                    <span>{{ stage.name }}</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="is-fluid" ref="contents">
              <div
                class="is-hidden"
                :data-tab="'stage_' + sidx"
                v-for="(stage, sidx) in meta.settings.stages || []"
                :key="sidx"
              >
                <label class="label"> {{ $t("stage name") }} </label>
                <div class="columns is-vcentered">
                  <div class="column">
                    <input
                      class="input"
                      type="text"
                      v-model="stage.name"
                      :placeholder="$t('stage name')"
                    />
                  </div>
                  <div class="column is-narrow">
                    <div
                      class="button is-danger is-small"
                      @click="remove_stage(index)"
                    >
                      <span class="icon">
                        <i class="fa fa-trash"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <div
                    class="button is-primary is-small is-pulled-right"
                    @click="add_activity(sidx)"
                  >
                    <span class="icon">
                      <i class="fa fa-plus"></i>
                    </span>
                    <span>{{ $t("add activity") }}</span>
                  </div>
                  <label class="label"> {{ $t("activities") }} </label>
                  <div class="control">
                    <ul>
                      <li
                        v-for="(activity, aidx) in stage.activities || []"
                        :key="aidx"
                        class="mb-0"
                      >
                        <div class="box">
                          <div class="columns is-vcentered">
                            <div class="column">
                              <input
                                class="input"
                                type="text"
                                v-model="activity.name"
                                :placeholder="$t('activity name')"
                              />
                            </div>
                            <div class="column is-narrow">
                              <div
                                class="button is-danger is-small"
                                @click="remove_activity(aidx, sidx)"
                              >
                                <span class="icon">
                                  <i class="fa fa-trash"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column">
                              <label class="label"> {{ $t("score") }} </label>
                              <input
                                class="input"
                                type="text"
                                v-model="activity.score"
                                :placeholder="$t('score')"
                              />
                            </div>
                            <div class="column">
                              <label class="label"> {{ $t("weight") }} </label>
                              <input
                                class="input"
                                type="text"
                                v-model="activity.weight"
                                :placeholder="$t('weight')"
                              />
                            </div>
                            <div class="column">
                              <label class="label"> {{ $t("helper") }} </label>
                              <input
                                class="input"
                                type="text"
                                v-model="activity.weight"
                                :placeholder="$t('weight')"
                              />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  change_active_tab,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import { v4 } from "uuid";
// import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "SectionAssignModal",
  components: { GenericModal /* GenericDropdown */ },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.uuid;
    },
  },
  methods: {
    change_active_tab,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    save() {
      let v = this;
      put("/professor-portal/classroom", { ...v.meta })
        .then(() => {
          v.$emit("classroom_updated");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
    },
    edit(classroom) {
      let v = this;
      v.set_initial_state();
      get("/professor-portal/classroom", { uuid: classroom.uuid })
        .then((response) => {
          v.meta = response;
          // v.meta = {
          //   professor_id: response.professor_id,
          //   course_id: response.course_id,
          //   settings: response.settings,
          //   uuid: response.uuid,
          //   period_id: response.period_id,
          // };
        })
        .catch((error) => {
          console.error(error);
          error_message(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    add_activity(stage_index) {
      let v = this;
      if (!v.meta.settings.stages[stage_index].activities)
        v.meta.settings.stages[stage_index].activities = [];
      v.meta.settings.stages[stage_index].activities.push({
        name: `${v.$t("activity")} ${
          v.meta.settings.stages[stage_index].activities.length + 1
        }`,
        id: v4(),
      });
      // if (!v.meta.settings.activities) v.meta.settings.activities = [];
      // v.meta.settings.activities.push({ name: "" });
    },
    remove_activity(activity_index, stage_index) {
      let v = this;
      if (v.meta.settings.stages[stage_index].activities) {
        v.meta.settings.stages[stage_index].activities.splice(
          activity_index,
          1
        );
      }
      // if (v.meta.settings.activities) {
      //   v.meta.settings.activities.splice(index, 1);
      // }
    },
    add_stage() {
      let v = this;
      if (!v.meta.settings.stages) v.meta.settings.stages = [];
      v.meta.settings.stages.push({
        name: `${v.$t("stage")} ${v.meta.settings.stages.length + 1}`,
        activities: [],
        id: v4(),
      });
    },
    remove_stage(index) {
      let v = this;
      if (v.meta.settings.stages) {
        v.meta.settings.stages.splice(index, 1);
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
